import { render, staticRenderFns } from "./BuyRegister.vue?vue&type=template&id=528a4da2&scoped=true&"
import script from "./BuyRegister.vue?vue&type=script&lang=js&"
export * from "./BuyRegister.vue?vue&type=script&lang=js&"
import style0 from "./BuyRegister.vue?vue&type=style&index=0&id=528a4da2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a4da2",
  null
  
)

export default component.exports